export default __webpack_public_path__ + "static/media/silverBadge.54e5a1ba.svg";